import escape from 'validator/lib/escape';
import blacklist from 'validator/lib/blacklist';

export function sanitize(input: string): string {
  const escapedInput = escape(input);
  const cleanedInput = blacklist(escapedInput, ';\\-');
  return cleanedInput;
}
